import { render, staticRenderFns } from "./p06.vue?vue&type=template&id=4f53471d&scoped=true&"
import script from "./p06.vue?vue&type=script&lang=js&"
export * from "./p06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f53471d",
  null
  
)

export default component.exports